import * as React from 'react'
import styled from 'styled-components'
import * as SC from "./style"
import { Breadcrumb as BreadcrumbBootStrap } from 'react-bootstrap'
import Props from './props'
import { withRouter } from 'react-router-dom'

// import ContentLoader from 'react-content-loader'
// const LoaderBreadcrumb = () => (
//   <ContentLoader
//     height={3}
//     width={200}
//     speed={2}
//     primaryColor="#f3f3f3"
//     secondaryColor="#ecebeb"
//   >
//     <rect x="0" y="0" rx="0" ry="0" width="10" height="3" />
//     <rect x="12" y="0" rx="0" ry="0" width="30" height="3" />
//   </ContentLoader>
// )

const StyledBreadcrumb = styled(BreadcrumbBootStrap)`
  margin-bottom: 15px;
  height: 26px;
`

function Breadcrumb(props: Props) {
  if (!props.datas) {
    return (<div style={{ height:26 }} />);
  }

  const goTo = (link: string) => {
    return (): void => {
      props.history.push(link)
    }
  }

  return (
    <SC.BreadCrumb>
    <StyledBreadcrumb className={props.className} style={{padding:"18px 0px"}}>
      {props.datas.map((element: any, key: number) => {
        
        if (typeof element === 'string') {
          
          element = { text: element, active: false }
        }

        if (element.text === "Welcome, Gérard") {
          return "";
        }

        return (
            <li key={key} className={element.active === true ? 'active' : ''}>
            <a onClick={goTo(element.link)}>{element.text}</a>
          </li>
        )
      })}
    </StyledBreadcrumb>
    </SC.BreadCrumb>
  )
}

export default withRouter(Breadcrumb)



// WEBPACK FOOTER //
// ./src/presentations/widgets/Breadcrumb/index.tsx